module.exports = __webpack_public_path__ + "whitemantis.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/whitemantis.png
// module id = 895
// module chunks = 0